import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import format from 'date-fns/format';

import TrolleyMenuBookingSlot from './TrolleyMenuBookingSlot';
import TrolleyMenuHeaderSummary from '[theme-lib]/apps/trolleyMenu/containers/TrolleyMenuHeaderSummary';

import basketModes from 'apps/basket/utils/basketModes';

export default class TrolleyMenuHeader extends PureComponent {
  static propTypes = {
    basket: PropTypes.shape({
      mode: PropTypes.oneOf(Object.values(basketModes)).isRequired,
      value: PropTypes.number.isRequired,
      numberOfItems: PropTypes.number.isRequired,
    }).isRequired,
    deliverySlot: PropTypes.object,
    onCancelOrderChanges: PropTypes.func.isRequired,
  };

  render() {
    const { basket, deliverySlot } = this.props;
    const TIME_FORMAT = 'h:mm a';

    return (
      <div className="hd-trolleyMenuHeader">
        <TrolleyMenuHeaderSummary />

        {(basket.mode === basketModes.EDIT || basket.mode === basketModes.REORDER) && (
          <div className="hd-trolleyMenuHeader__editModeInfoWrapper">
            {deliverySlot && deliverySlot.cutoffTime && (
              <p className="hd-trolleyMenuHeader__editModeInfo">
                You can edit this order until {format(deliverySlot.cutoffTime, TIME_FORMAT)} on{' '}
                {format(deliverySlot.cutoffTime, 'dddd, Do MMMM YYYY')}
              </p>
            )}
            <button
              onClick={this.props.onCancelOrderChanges}
              className="btn-tertiary hd-trolleyMenuHeader__editModeInfoBtn"
            >
              Cancel changes
            </button>
          </div>
        )}

        <TrolleyMenuBookingSlot deliverySlot={deliverySlot} />
      </div>
    );
  }
}
